<template lang="pug">
div
  el-card(shadow="hover").card-container
    app-divider(label="Dados do VTN RR: ", :addMarginTop="false").margin-bottom
    div.center
      el-col(:span='16')
        el-row.flexRow(:gutter="16")
          app-label.appLabel(label="Área total do imóvel georreferenciado (ha):", :required="required")
          validation-provider(rules="required|notZero", v-slot="{ errors }", name="area")
            app-double-input.appInput(
              name='Área',
              :precision="4",
              :onkeypress="onlyInputNumbers",
              @change="atualizaValorModuloFiscal",
              v-model="vtnRequest.areaTotalImovelGeorreferenciado",
              :hasValidationError="!!errors.length"
            )
            span.help.erro {{ errors[0] }}
        el-row.flexRow(:gutter="16")
          app-label.appLabel(label="Gleba:")
          validation-provider(rules="required", v-slot="{ errors }", name="Gleba")
            el-input.appInput(
              :class="{'input erro' : !!errors.length}"
              name='Gleba',
              :maxlength="50",
              v-model="vtnRequest.gleba"
            )
            span.help.erro {{ errors[0] }}
        el-row.flexRow(:gutter="16")
          app-label.appLabel(label="Tempo de ocupação (em anos):", :required="required")
          validation-provider(rules="required", v-slot="{ errors }", name="Tempo de ocupação")
            el-input.appInput(
              name='Tempo de ocupação',
              :maxlength="3",
              :onkeypress="onlyInputNumbers",
              v-model="vtnRequest.tempoOcupacao"
              :class="{'input erro' : !!errors.length}"
            )
            span.help.erro {{ errors[0] }}
        el-row.flexRow(:gutter="16")
          app-label.appLabel(label="Distância da capital Boa Vista em linha reta (Km):", :required="required")
          validation-provider(rules="required|notZero", v-slot="{ errors }", name="Distância da capital")
            app-double-input.appInput(
              name='Distância da capital',
              :precision="1",
              :onkeypress="onlyInputNumbers",
              v-model="vtnRequest.distanciaBoaVista"
              :hasLimitValue="6"
              :hasValidationError="!!errors.length"
              :class="{'input erro' : !!errors.length}"
            )
            span.help.erro {{ errors[0] }}
        el-row.flexRow(:gutter="16")
          app-label.appLabel(label="Há conduta ou atividade lesiva ao meio ambiente?", :required="required")
          el-radio-group.radio-group(
            name="Conduta ou atividade lesiva",
            v-model="vtnRequest.condutaLesivaMeioAmbiente"
          )
            el-radio.radio(:label="false") Inexistente
            el-radio.radio(:label="true") Existente

      el-col(:span='16')
        el-row.flexRow(:gutter="16")
          app-label.appLabel(label="Módulo Fiscal do Múnicípio - MF (ha):", :required="required")
          app-double-input.appInput(
            name='Módulo Fiscal do Múnicípio',
            :precision="2",
            :onkeypress="onlyInputNumbers",
            :disable="disable",
            v-model="vtnRequest.moduloFiscal"
          )

        el-row.flexRow(:gutter="16" v-if="isRoraima")
          app-label.appLabel(label="Munícipio:", :required="required")
          div(class="el-input-group el-input-group--prepend appInput")
            validation-provider(rules="required", v-slot="{ errors }", name="distancia")
              el-input(
                v-if="temMunicipio"
                v-model="vtnRequest.municipio.nome"
                :disabled="disable",
              )

              el-select(
                v-if="!temMunicipio"
                v-model="vtnRequest.municipio.id"
                placeholder="Selecione"
                value-key="Município"
                @change="calculaModuloFiscalPorMunicipio"
              )
                el-option(
                  v-for="municipio in municipios",
                  :key="municipio.id",
                  :label="municipio.nome",
                  :value="municipio.id"
                )
              span.help.erro {{ errors[0] }}
        el-row.flexRow(:gutter="16")
          app-label.appLabel(label="Número de Módulos fiscais:", :required="required")
          app-double-input.appInput(
            name='Número de Módulos fiscais',
            :precision="2",
            :onkeypress="onlyInputNumbers",
            :disable="disable",
            v-model="vtnRequest.qtdModuloFiscal"
          )
</template>

<script>
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import AppLabel from '@/components/AppLabel'
import AppDoubleInput from '@/components/AppDoubleInput'
import AppDivider from '@/components/AppDivider.vue'
import AppDisplay from '@/components/AppDisplay'
export default {
  mixins: [onlyInputNumbers],
  components: {
    AppDivider,
    AppDisplay,
    AppLabel,
    AppDoubleInput
  },

  props: {
    required: {
      type: Boolean,
      default: true
    },

    vtnRequest: {
      type: Object,
      required: true
    },

    municipios: {
      type: Array
    }
  },

  data () {
    return {
      input: '',
      disable: true,
      temMunicipio: false
    }
  },

  created () {
    this.vtnRequest.areaTotalImovelGeorreferenciado = this.vtnRequest.areaTotalImovelGeorreferenciado ? this.vtnRequest.areaTotalImovelGeorreferenciado : this.vtnRequest.areaRequerida
    this.temMunicipio = !!this.vtnRequest?.municipio
  },

  computed: {
    isRoraima () {
      return process.env.ESTADO === 'rr'
    }
  },

  methods: {
    calcularPercentual (coeficienteAngular, area, coeficienteLinear) {
      return (coeficienteAngular * area) + coeficienteLinear
    },

    calcularValorFinalImovel (percentual, valorMinimo, area) {
      return ((percentual / 100) * valorMinimo) * area
    },

    calculaModuloFiscalPorMunicipio (value) {
      this.$emit('calculaModuloFiscal', value)
    },
    atualizaValorModuloFiscal () {
      this.vtnRequest.qtdModuloFiscal = this.vtnRequest.areaTotalImovelGeorreferenciado / this.vtnRequest.municipio.mf
    }

  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/element-variables.scss";

.card-container {
  margin: 20px;
  border-radius: 10px;
}

.margin-bottom {
  margin-bottom: 20px;
}

.center {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 7%;
}
.flex {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: inherit;
}

.el-row {
  margin-bottom: 20px;
}

.flexRow {
  display: flex;
}

.appLabel {
  flex: 1;
}

.appInput {
  flex: 0.5;
}

.el-input__inner {
  border-radius: 4px;
  font-size: 14px;
}

.el-input-group__append {
  color: $--color-text-regular
}

</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/components/InformarDadosRR.vue